import { graphql } from "gatsby"
import { gql } from "@apollo/client"

export const query = graphql`
  fragment heroEntry on Craft_hero_default_Entry {
    uid
    title
    heroStyle
    heroTitle
    heroDescription
    heroVideoURL
    heroLinks {
      ... on Craft_heroLinks_BlockType {
        uid
        buttonLink
        style
      }
    }
    heroPicture {
      ...mainFileUploadsAsset
    }
  }
`

export const heroEntry = gql`
  fragment heroEntry on hero_default_Entry {
    uid
    title

    heroStyle
    heroTitle
    heroDescription
    heroVideoURL
    heroLinks {
      ... on heroLinks_BlockType {
        uid
        buttonLink
        style
      }
    }
    heroPicture {
      ...mainFileUploadsAsset
    }
  }
`
